const MenuIcon = ({ onClick, open = false }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative -ml-2.5 flex h-[38px] w-[38px] shrink-0 items-center justify-center"
      aria-label={open ? "Close side navigation menu" : "Toggle side navigation menu"}
    >
      <span className="relative h-px w-[15px]">
        <span
          className={`absolute left-0 h-px w-full bg-black transition-transform duration-300 ease-in-out ${
            open ? "translate-y-0 rotate-45" : "-translate-y-1"
          }`}
        />

        <span
          className={`absolute left-0 h-px w-full bg-black transition-transform duration-300 ease-in-out ${
            open ? "translate-y-0 -rotate-45" : "translate-y-1"
          }`}
        />
      </span>
    </button>
  );
};

export default MenuIcon;
